const send = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M2.74%202.252L22.236%2012%202.74%2021.748l1.365-9.555.772-.193-.772-.193L2.74%202.252zm2.52%203.496l.635%204.445L13.123%2012l-7.228%201.807-.635%204.445L17.764%2012%205.26%205.748z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  send as default
};
//# sourceMappingURL=send.svg.es.js.map
